import React from 'react'
import ProtectionPage from '../protection'

const ProtectionPageDe = () => {
    return <ProtectionPage languageCode="de" />
}

export default ProtectionPageDe
